import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';
import { AmplitudeService, FunnelStepService } from '../../interfaces';
import { AmplitudeServiceWithFunnelContext } from './AmplitudeServiceWithFunnelContext';
import { AmplitudeServiceWithFunnelStep } from './AmplitudeServiceWithFunnelStep';
import { AmplitudeServiceWithMonoLanding } from './AmplitudeServiceWithMonoLanding';

export class AmplitudeServiceBuilder {
  constructor(private amplitudeService: AmplitudeService) {}

  addFunnelStep(funnelStepService: FunnelStepService): this {
    this.amplitudeService = new AmplitudeServiceWithFunnelStep(
      this.amplitudeService,
      funnelStepService,
    );

    return this;
  }

  addFunnelContext(funnelSettingsService: FunnelSettingsServiceInterface): this {
    this.amplitudeService = new AmplitudeServiceWithFunnelContext(
      this.amplitudeService,
      funnelSettingsService,
    );

    return this;
  }

  addMonoLanding(isMonoLanding: boolean): this {
    this.amplitudeService = new AmplitudeServiceWithMonoLanding(
      this.amplitudeService,
      isMonoLanding,
    );

    return this;
  }

  getResult(): AmplitudeService {
    return this.amplitudeService;
  }
}
